<template>
  <ts-page-layout class="its-classroom" :class="user.userType" :style="{'z-index':previewShow?20:2}" center v-loading="isLoading" element-loading-text="文件上传中..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0)">
    <template v-if="user && user.userType == 'TEACHER'">
      <search-nav ref="searchNav" :father-action="fileAction" :sortedBy="sortedBy" :showMoreOption="showMoreOption" :searchParams="searchParams" :list="list" :treeData="treeData" :defaultProps="defaultProps" @subject-change="subjectChange" @node-click="moveToAction"></search-nav>
      <download-qr-code></download-qr-code>
    </template>
    <p v-show="selectFileCount > 0" class="its-file-count">已选择{{selectFileCount}}项</p>
    <data-list :sortedBy="sortedBy" :user="user" @showMoreOption="isShowMoreOption" ref="dataList" :searchParams="searchParams" @show-preview="showPreview"></data-list>
    <move-to-dialog ref="moveToDialog" :treeData="treeData" :defaultProps="defaultProps" :title="title" :dialogVisible="dialogVisible" :defaultCheckedKeys="defaultCheckedKeys" :father-action="moveToAction"></move-to-dialog>
    <create-dialog :type="optionType" :canClick="canClick" :dialogVisible="createDialogVisible" :father-action="createAction"></create-dialog>
    <modify-class-dialog :list="list" :items="items" :dialogVisible="modifyDialogVisible" :father-action="modifyAction"></modify-class-dialog>
    <confirm-dialog :visible="confirmDialogVisible" :father-action="confirmAction"></confirm-dialog>
  </ts-page-layout>
</template>
<script>
import SearchNav from './components/SearchNav'
import DataList from './components/DataList'
import CreateDialog from './components/CreateDialog'
import MoveToDialog from './components/MoveToDialog'
import ModifyClassDialog from './components/ModifyClassDialog'
import ConfirmDialog from './components/ConfirmDialog'
import { classSpaceApi } from '../../../utils/api'
import { getRequest } from '../../../utils/http'
import DownloadQrCode from '../home/components/DownloadQrCode.vue'
export default {
  name: 'ClassSpace',
  components: {
    SearchNav,
    DataList,
    CreateDialog,
    ModifyClassDialog,
    MoveToDialog,
    ConfirmDialog,
    DownloadQrCode
  },
  data() {
    return {
      defaultCheckedKeys: 0,
      upload: {
        visible: false
      },
      isLoading: false,
      defaultProps: {
        label: 'fileName',
        children: 'childFolder',
        isLeaf: 'isLeaf'
      },
      sortedBy: 'table',
      // user: {},
      showMoreOption: false,
      items: [],
      list: [],
      modifyDialogVisible: false,
      item: {},
      optionType: 'create',
      createDialogVisible: false,
      title: '移动到',
      dialogVisible: false,
      searchParams: {// 搜索条件
        fileId: "0",
        keyword: "",
        filePath: "0",
      },
      treeData: [
        {
          id: 0,
          fileName: '全部文件',
          children: []
        }
      ],
      selectedShareClassList: [], // 选定的可见班级列表
      canClick: true,
      timer: null,
      previewShow: false,
      confirmDialogVisible: false,
      subject: {},
      selectFileCount: 0
    }
  },
  computed: {
    loginUser: function () {
      return this.$store.state.user
    },
    user: function () {
      return this.$store.state.user
    }
  },
  created() {
    this.$root.activeNavigation()
  },
  mounted() {
    // this.user = this.$store.state.user
    console.log(this.user)
  },
  watch: {
    loginUser: async function () {
      this.user = this.$store.state.user
      if (this.user.userType !== 'STUDENT') {
        await this.jumpGuideIfNeed()
      }
      console.log('user', this.user)
    }
  },
  methods: {
    subjectChange: function (data) {
      // this.subject = JSON.parse(JSON.stringify(data))
      this.searchParams.filePath = '0'
      this.searchParams.fileId = 0
      this.searchParams.keyword = ''
      if (this.$refs.searchNav) {
        this.$refs.searchNav.searchKey = ''
      }
      this.sortedBy = 'table'
      this.searchParams.orderbyType = "UPDATE_TIME_DESC"
      if (this.$refs.dataList) {
        this.$refs.dataList.orderType = 'UPDATE_TIME_DESC'
      }
      this.$refs.dataList.changeSubject(data)
    },
    async jumpGuideIfNeed() {
      const resp = await getRequest(location.origin + '/ibook/personal/sum-data', {})
      if (resp.body && !resp.body.hasClass) {
        this.$router.push('/guide/add-class?type=no_class&name=classpace')
      } else {
        const resp = await getRequest(location.origin + '/ibook/user-base-api/has-courses', {})
        if (!resp.body) {
          this.$router.push('/guide/add-class?type=no_course&name=classpace')
        }
      }
    },
    showPreview: function (show) {
      this.previewShow = show
    },
    fileAction: function (data) {
      console.log(data)
      if (data.type === 'sorted') {
        this.sortedBy = data.sorted
      } else if (data.type === 'move') {
        this.defaultCheckedKeys = this.searchParams.fileId
        this.dialogVisible = true
      } else if (data.type === 'rename') {
        this.createDialogVisible = true
      } else if (data.type === 'edit') {
        this.modifyDialogVisible = true
      } else if (data.type === 'create') {
        //新建
        this.list = this.$refs.dataList.shareClassList
        if (!this.list || this.list.length === 0) {
          this.confirmDialogVisible = true
        } else {
          this.optionType = data.type
          const filePath = this.searchParams.filePath.split('/')
          if (filePath.length >= 4) {
            this.$message.warning('最多只允许创建三级目录')
            return
          }
          this.createDialogVisible = true
        }
      } else if (data.type === 'search') {
        //搜索
        this.searchParams.keyword = data.searchKey
        this.$refs.dataList.getDataList()
      } else if (data.type === 'delete') {
        //删除
        this.deleteItems()
      } else if (data.type === 'upload') {
        this.list = this.$refs.dataList.shareClassList
        if (!this.list || this.list.length === 0) {
          this.confirmDialogVisible = true
        } else {
          // this.modifyDialogVisible = true
          // this.$refs.searchNav
          this.$refs.searchNav.openUpload()
        }
      } else if (data.type === 'upload-progress') {
        this.isLoading = true
        //默认十秒钟超时
        if (this.timer) {
          clearTimeout(this.timer)
        }
        this.timer = setTimeout(() => {
          this.$message.error('上传超时，请刷新页面后重试')
          this.isLoading = false
        }, 1000 * 10);
      } else if (data.type === 'upload-error') {
        this.$message.error(data.message)
        this.isLoading = false
      } else if (data.type === 'upload-ok') {
        this.uploadFile(data.upload)
      }
    },
    isShowMoreOption: function (data) {
      this.selectFileCount = data
      this.showMoreOption = data > 0
    },
    createFolder: function (name) {
      let dataList = this.$refs.dataList
      //新建文件夹
      let params = {
        fileName: name,
        filePath: this.searchParams.filePath,
        parentId: this.searchParams.fileId,
        shareClazzList: dataList.shareClassList,
        source: "I_CLASS",
        subjectId: dataList.subject.id
      }
      classSpaceApi.saveFolder(params).then((res) => {
        if (res.success) {
          this.$message.success('新建成功')
          this.createDialogVisible = false
          this.$refs.dataList.getDataList()
        } else {
          this.$message.error(res.message)
        }
        this.canClick = true
      })
    },
    moveToAction: function (data) {
      if (data.type === 'close') {
        this.dialogVisible = false
      } else if (data.type === 'nodeClick') {
        if (!data.item.children || data.item.children.length == 0) {
          let params = {
            subjectId: this.$refs.dataList.subject.id,
            parentId: data.item.id
          }
          this.getTreeDatas(params, data.item)
        }
      } else if (data.type === 'ok') {
        this.moveFile(data.item)
      }
    },
    createAction: function (data) {
      console.log(data)
      if (data.type === 'close') {
        this.createDialogVisible = false
      }
      if (data.type === 'ok') {
        this.canClick = false
        this.createFolder(data.fileName)
      }
    },
    modifyAction: function (data) {
      if (data.type === 'close') {
        this.modifyDialogVisible = false
      }
      if (data.type === 'ok') {
        this.selectedShareClassList = data.items
        console.log('可见班级', this.selectedShareClassList)
        this.$refs.searchNav.openUpload()
        this.modifyDialogVisible = false
      }
    },
    confirmAction: function () {
      this.confirmDialogVisible = false
    },
    deleteItems: function () {
      this.$confirm('确定要删除选中的文件吗？删除后将无法恢复', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        customClass: 'cs-delete-dialog'
      }).then(() => {
        this.deleteFile()
      }).catch(() => {
      });
    },
    deleteFile: function () {
      classSpaceApi.deleteFile(this.$refs.dataList.selectedItems).then((res) => {
        if (res.success) {
          this.$message.success('删除成功')
          this.$refs.dataList.getDataList()
          this.$refs.dataList.selectedItems = []
        } else {
          this.$message.error(res.message)
        }
      })
    },
    getTreeDatas: function (params, node) {
      console.log('getTreeData', params, node)
      classSpaceApi.getFolderList(params).then((res) => {
        console.log(res)
        if (res.success) {
          let result = res.body
          if (!result) {
            this.$message.error('抱歉！您不能将自己任教科目以外的资源分享到班级空间！')
          }
        } else {
          this.$message.error(res.message)
        }
      })
    },
    moveFile: function (data) {
      console.log(data)
      let dataList = this.$refs.dataList
      let fileIds = []
      dataList.tableData.forEach((item) => {
        if (dataList.selectedItems.indexOf(item.id) >= 0) {
          let fileId = {
            id: item.id,
            filePath: item.filePath
          }
          fileIds.push(fileId)
        }
      })
      let checkOk = true
      fileIds.forEach((item) => {
        //要判断：文件夹不能移入自己或自己的子文件夹
        if (data.id == item.id || data.filePath.indexOf(item.id) >= 0) {
          this.$message.error('文件夹不能移入自己或自己的子文件夹')
          checkOk = false
          return
        }
      })
      if (!checkOk) {
        return
      }
      let params = {
        fileIds: fileIds,
        parentId: data.id,
        filePath: data.filePath
      }
      classSpaceApi.moveFile(params).then((res) => {
        if (res.success) {
          this.$message.success('移动成功')
          this.dialogVisible = false
          dataList.getDataList()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    uploadFile: function (files) {
      let file = files[0]
      let dataList = this.$refs.dataList
      let params = []
      files.forEach(file => {
        let param = {
          fileName: file.fileName,
          filePath: file.relativePath,
          fileSize: file.size,
          extension: file.extension,
          shareClazzList: JSON.stringify(file.shareClazzList),
          subjectId: this.$store.state.subjectId,
          classSpaceId: file.classSpaceId
        }
        params.push(param)
      })
      this.searchParams.filePath = file.path
      this.searchParams.fileId = file.classSpaceId
      classSpaceApi.uploadBatchFile(params).then((res) => {
        console.log(res)
        this.isLoading = false
        if (res.success) {
          this.$message.success('上传成功')
          if (this.timer) {
            clearTimeout(this.timer)
          }
          if (this.$refs.searchNav) {
            this.$refs.searchNav.upload.visible = false
            this.$refs.searchNav.clearFileList()
          }
          dataList.getDataList()
          // 统计用户上传行为
          let params = {
            subjectId: this.$store.state.subjectId,
            classSpaceAction: 'UPLOAD'
          }
          classSpaceApi.calcUserAction(params)
        } else {
          this.$message.error(res.message)
        }
      })
    }
  }
}
</script>
<style scoped>
.its-classroom {
  min-height: calc(100vh - 126px);
  background: transparent;
  position: relative;
  z-index: 2;
  padding-top: 16px;
}
.its-classroom >>> .page-div {
  background: transparent;
}

.its-classroom >>> .ts-base-btn.delete {
  position: absolute;
  top: 159px;
  left: 160px;
  z-index: 10;
  width: 64px;
}

.its-classroom >>> .ts-base-btn.move {
  position: absolute;
  top: 159px;
  left: 236px;
  z-index: 10;
}

.its-classroom.TEACHER >>> .ts-base-btn.move,
.its-classroom.TEACHER >>> .ts-base-btn.delete {
  top: 223px;
}

.its-file-count {
  position: absolute;
  top: 166px;
  left: 62px;
  z-index: 10;
  background: white;
}

.its-classroom.TEACHER >>> .its-file-count{
  top: 230px;
}
</style>
